import * as React from "react"
import { Box, Chip } from "@mui/material"


export default function ChipBlock({ listElements, ...props }) {
    const boxChipBlock= {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        justifyContent: 'center',
        pl: 2,
        pb: 2,
        div: {
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
        }
    }
    return <Box sx={{ ...boxChipBlock, ...props?.sx }}>
        <Box>
            { listElements?.length > 0 && listElements.map((item, idx) =>
                <Chip
                    label={item}
                    key={idx}
                    sx={{ mr: 1, mt: 1, textAlign: 'center', backgroundColor: "disabled.dark" }}
                />
            )}
        </Box>
    </Box>
}